import api from "@/apiConfig/api";
import apiV2 from "@/apiConfig/api-v2";
import { ElMessage } from "element-plus";

export default {
  namespaced: true,
  state() {
    return {
      products: [],
      transactions: [],
    };
  },
  actions: {
    async getProducts(ctx, { branch_id }) {
      console.log("get", branch_id);
      ctx.state.products = await api
        .get("/shop/transaction", {
          params: {
            company_id: branch_id,
          },
        })
        .then((res) => res.data)
        .catch(() => []);
    },
    async getTransactions(ctx, { branch_id }) {
      ctx.state.transactions = await apiV2
        .get("/shoptransactions", {
          params: {
            branch_id,
          },
        })
        .then((res) => res.data)
        .catch(() => []);
    },

    async addProduct(ctx, data) {
      await api
        .post("/shop/transaction", data)
        .then(() => {
          const { branch_id } = data[0];
          ctx.dispatch("getProducts", { branch_id });
          ctx.dispatch("getTransactions", { branch_id });
        })
        .catch((err) => {
          ElMessage.error(err);
        });
    },
  },
};
